import { getCookie } from 'cookies-next/client';

export const oneTrust = {
  peformanceCookiesOptOut: 'C0002:0',
  targetingCookiesOptOut: 'C0004:0',
};

export const rejectedPerformanceCookies = (): boolean => {
  if (getCookie('OptanonConsent')?.includes(oneTrust.peformanceCookiesOptOut)) {
    if (getCookie('OptanonAlertBoxClosed')) {
      return true;
    }
  }
  return false;
};

export const rejectedTargetingCookies = (): boolean => {
  if (getCookie('OptanonConsent')?.includes(oneTrust.targetingCookiesOptOut)) {
    if (getCookie('OptanonAlertBoxClosed')) {
      return true;
    }
  }
  return false;
};

export const agreedToCookies = (): boolean => {
  if (rejectedPerformanceCookies() || rejectedTargetingCookies()) {
    return false;
  }
  return true;
};
